import { TableCard } from '../../../../components'
import { ClienteHeading } from '../empresasCliente-list/components/ClienteHeading'
import { ExameClienteListHeader } from './components/header/ExameClienteListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { ListViewProvider } from './core/ListViewProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ExameClienteTable } from './table/ExameClienteTable'

const ExameClienteList = () => {
  return (
    <>
      <ClienteHeading />
      <TableCard>
        <ExameClienteListHeader />
        <ExameClienteTable />
      </TableCard>
    </>
  )
}

export const ExameClienteListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <ListFiltersProvider>
          <ExameClienteList />
        </ListFiltersProvider>
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
